var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTm = function SvgTm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M12 0c-.896 0-1.77.098-2.61.285l-.52 11.714.52 11.715c.84.186 1.714.285 2.61.285 6.627 0 12-5.372 12-12 0-6.627-5.373-12-12-12ZM3.13 3.917A11.956 11.956 0 0 0 0 12c0 3.113 1.186 5.95 3.13 8.082L3.652 12 3.13 3.917Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M17.551 9.052a3.653 3.653 0 0 0-1.496-4.327 3.652 3.652 0 1 1-2.41 6.715 3.653 3.653 0 0 0 3.906-2.388ZM14.277 4.274l-.513.663-.79-.283.473.693-.513.663.804-.235.472.693.025-.838.805-.235-.789-.283.026-.838Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m15.662 6.435-.513.663-.789-.283.472.693-.513.663.805-.235.472.693.025-.838.805-.235-.789-.283.025-.838ZM11.833 5.06l-.513.663-.789-.283.472.693-.513.663.805-.235.472.693.025-.838.805-.235-.79-.283.026-.838ZM11.778 7.535l-.513.662-.79-.283.473.693-.513.663.804-.235.472.693.025-.838.805-.235-.789-.283.026-.837ZM14.132 8.38l-.513.663-.789-.283.472.693-.513.662.805-.234.472.692.025-.838.805-.234-.79-.283.026-.838Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M3.13 3.917v16.166a11.987 11.987 0 0 0 6.26 3.632V.285a11.987 11.987 0 0 0-6.26 3.632Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m5.52 6.318-1.048-.781V4.433l1.048-.781h1.482l1.048.78v1.105l-1.048.78H5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9811",
    d: "M6.261 3.652H5.52l-1.048.78v.54h1.79v-1.32ZM6.26 6.317h.742l1.048-.781v-.563H6.26v1.344Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m5.52 20.349-1.048-.781v-1.105l1.048-.78h1.482l1.048.78v1.105l-1.048.78H5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9811",
    d: "M6.261 17.683H5.52l-1.048.78v.54h1.79v-1.32ZM6.26 20.35h.742l1.048-.782v-.563H6.26v1.344Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "m5.52 13.332-1.048-.78v-1.105l1.048-.78h1.482l1.048.78v1.105l-1.048.78H5.52ZM8.087 15.051H7.63v-.456h-.802l-.567-.567-.568.567h-.802v.456h-.456v.913h.456v.457h.802l.568.567.567-.567h.802v-.457h.457v-.913ZM8.087 8.036H7.63v-.457h-.802l-.567-.567-.568.567h-.802v.457h-.456v.913h.456v.457h.802l.568.567.567-.567h.802v-.457h.457v-.913Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M6.783 11.48H5.739v1.043h1.044v-1.044ZM6.261 9.015a.522.522 0 1 0 0-1.044.522.522 0 0 0 0 1.044ZM6.261 16.03a.522.522 0 1 0 0-1.043.522.522 0 0 0 0 1.044Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgTm;